import React from 'react';
import { FlexboxGrid, Text } from 'rsuite';
import Notice from 'src/components/user-feedback/Notice';

interface BulkTaxErrorsProps {
  errors: Array<string>;
}

const MAX_ERRORS_TO_DISPLAY = 10;

export const BulkTaxError = ({ errors }: BulkTaxErrorsProps) => {
  if (errors.length === 0) {
    return null;
  }
  return (
    <Notice
      isMessageComponent
      showIcon={false}
      message={
        <FlexboxGrid>
          <FlexboxGrid.Item colspan={24}>
            <Text as="h5">Failed to validate your report</Text>
          </FlexboxGrid.Item>
          <FlexboxGrid.Item
            colspan={24}
            className="mt-12 mb-12"
          >
            <Text>
              Please fix the errors below and re-upload the corrected
              spreadsheet to continue
            </Text>
          </FlexboxGrid.Item>
          <FlexboxGrid.Item colspan={24}>
            <ul>
              {errors.slice(0, MAX_ERRORS_TO_DISPLAY).map((message) => (
                <li key={message}>{message}</li>
              ))}
              {errors.length > MAX_ERRORS_TO_DISPLAY && (
                <li>+ {errors.length - MAX_ERRORS_TO_DISPLAY} more errors</li>
              )}
            </ul>
          </FlexboxGrid.Item>
        </FlexboxGrid>
      }
    />
  );
};
